import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  resetOnSuccess(event) {
    if (event.detail.success) {
      this.element.reset();
    }
  }
}
